<template>
  <v-data-table
    :headers="headers"
    :items="groupedInvoices"
    fixed-header
    height="70vh"
    :items-per-page="-1"
    hide-default-footer
    show-expand
    single-expand
    expand-icon="mdi-chevron-down"
    :expanded.sync="expanded"
    item-key="clientId"
    :item-class="highlightExpandedRow"
    @click:row="rowClicked"
    :key="groupedInvoices.length"
  >
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="expandedRow">
        <v-card class="mb-2">
          <invoices-table
            :clientId="item.clientId"
            :noEdit="noEdit"
          ></invoices-table>
        </v-card>
      </td>
    </template>
  </v-data-table>
</template>
<script>
import { formatCurrency, formatDate } from "../../utils/format-utils";
import InvoicesTable from "./invoices-table";
export default {
  props: ["noEdit"],
  components: {
    InvoicesTable,
  },
  data() {
    return {
      headers: [
        { text: "Client", value: "clientName" },
        { text: "OSIS", value: "clientOsis" },
        { text: "Dates of Service", value: "datesOfService" },
        { text: "Service", value: "serviceName" },
        { text: "Invoice Date", value: "invoiceDate" },
        {
          text: "Total Billed",
          value: "billedAmount",
          sortable: false,
        },
        {
          text: "Total Payment",
          value: "paidAmount",
          sortable: false,
          cellClass: "font-weight-medium",
        },
      ],
      expanded: [],
    };
  },
  computed: {
    batch() {
      return this.$store.state.paymentBatchModule.selectedBatch;
    },
    groupedInvoices() {
      // group invoices by client
      var grouped = this.batch?.invoicePayments
        .sort((a, b) => a.clientLastName.localeCompare(b.clientLastName))
        .reduce((acc, item) => {
          const key = item.clientName;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(item);
          return acc;
        }, {});
      // flatten into array of client summary details
      return Object.values(grouped).map((group) => {
        var minDate = new Date(
          Math.min(...group.map((x) => new Date(x.dateOfService)))
        );
        var maxDate = new Date(
          Math.max(...group.map((x) => new Date(x.dateOfService)))
        );
        return {
          clientId: group[0].clientId,
          clientName: group[0].clientName,
          clientOsis: group[0].clientOsis,
          serviceName: group[0].serviceName,
          datesOfService: formatDate(minDate) + " - " + formatDate(maxDate),
          invoiceDate: formatDate(group[0].invoiceDate),
          billedAmount: formatCurrency(this.getTotal(group, "billedAmount")),
          paidAmount: formatCurrency(this.getTotal(group, "paidAmount")),
        };
      });
    },
  },
  methods: {
    getTotal(items, value) {
      return items.reduce((acc, val) => {
        return acc + val[value];
      }, 0);
    },
    rowClicked: function (row, { isExpanded }) {
      this.expanded = isExpanded ? [] : [row];
    },
    highlightExpandedRow: function (row) {
      return this.expanded[0]?.clientId === row.clientId && "expandedRow";
    },
  },
};
</script>
<style>
.expandedRow {
  background: #ccc;
}
</style>
